import React, { useState, useEffect } from "react";
import Table from "components/table/table";
import Select from "components/select";
import { ListeTransfers } from "helpers/api";
import moment from "moment";
import Modal from "components/Modal";
import { ToastContainer, toast } from "react-toastify";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.css";
import ConfirmAlert from "../../components/ConfirmAlert";
import { FnCancelTranfer } from "../../helpers/api";

const Home = () => {
  const [data, setData] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [dataTransfert, setDataTransfert] = useState(null);
  const [valueExp, setValueExp] = useState("");
  const [valueMontant, setValueMantant] = useState("");
  const [loading, setLoading] = useState(true);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [openAlert, setOpenAlert] = useState(false);
  const [transferId, setTransferId] = useState("");
  const options = [
    { value: "created", label: "En cours" },
    { value: "complete", label: "Terminé" },
    { value: "consulted", label: "Consulté" },
    { value: "canceled", label: "Annulé" },
    { value: "tous", label: "Tous" },
  ];
  const optionsPartner = [
    { value: "enda", label: "Enda" },
    { value: "izi", label: "Izi" },
    { value: "via_mobile", label: "Viamobile" },
    { value: "tous", label: "Tous" },
  ];
  const [selectedValue, setSelectedValue] = useState({
    value: "tous",
    label: "Tous",
  });
  const [selectedPartner, setSelectedPartner] = useState({
    value: "tous",
    label: "Tous",
  });
  const columns = [
    {
      key: "createdAt",
      label: "Date",
      customRenderers: (item) => (
        <div>{moment(item?.createdAt).format("DD/MM/YYYY hh:mm")}</div>
      ),
    },
    {
      key: "code",
      label: "Code",
    },
    {
      key: "em_firstname",
      label: "Expéditeur",
      customRenderers: (item) => (
        <div>
          {item?.em_firstname} {item?.em_lastname}
        </div>
      ),
    },
    {
      key: "dest_firstname",
      label: "Destinataire",
      customRenderers: (item) => (
        <div>
          {item?.dest_firstname} {item?.dest_lastname}
        </div>
      ),
    },
    {
      key: "amount",
      label: "M.EURO",
      customRenderers: (item) => (
        <div>{Math.round(Number(item?.sending_amount) * 1000) / 1000} EUR</div>
      ),
    },
    {
      key: "amounttnd",
      label: "M.TND",
      customRenderers: (item) => <div>{item?.amount} TND</div>,
    },
    {
      key: "network",
      label: "Partenaire",
      customRenderers: (item) => <div>{item?.network}</div>,
    },
    {
      key: "agentId",
      label: "Agence",
      customRenderers: (item) => <div>{item?.agentId}</div>,
    },

    {
      key: "status",
      label: "Statut",
      customRenderers: (item) => (
        <div>
          {item?.status === "created"
            ? "Créé"
            : item?.status === "complete"
            ? "Terminé"
            : item?.status === "consulted"
            ? "Consulté"
            : "Annulé"}
        </div>
      ),
    },
    {
      key: "distribution",
      label: "Date de distribution",
      customRenderers: (item) =>
        item?.completeAt ? (
          <div>{moment(item.completeAt).format("DD/MM/YYYY HH:mm")}</div>
        ) : null,
    },
  ];

  useEffect(() => {
    async function fetchData() {
      ListeTransfers()
        .then((response) => {
          if (response?.success) {
            setData(response?.transfers);
          }
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });
    }
    fetchData();
  }, []);

  const handleChangeMontant = (e) => {
    const inputValue = e.target.value;
    if (/^\d*\.?\d*$/.test(inputValue)) {
      setValueMantant(inputValue);
    }
  };

  const filteredData = data?.filter((item) => {
    const matchesStatus =
      selectedValue.value === "tous" || item?.status === selectedValue.value;
    const matchesCode = item?.code
      ?.toLowerCase()
      ?.includes(valueExp.toLowerCase());
    const matchesMontant = item?.amount?.toString()?.includes(valueMontant);
    const matchesDateRange =
      (!startDate || moment(item?.createdAt).isSameOrAfter(startDate, "day")) &&
      (!endDate || moment(item?.createdAt).isSameOrBefore(endDate, "day"));
    const matchesPartner =
      selectedPartner.value === "tous" ||
      item?.network === selectedPartner.value;
    return (
      matchesStatus &&
      matchesCode &&
      matchesMontant &&
      matchesDateRange &&
      matchesPartner
    );
  });

  const CancelTransferfn = () => {
    FnCancelTranfer({
      transferId: transferId,
    })
      .then((response) => {
        if (response?.success) {
          setData((prevData) =>
            prevData.map((item) =>
              item._id === transferId || item.id === transferId
                ? { ...item, status: "canceled" }
                : item
            )
          );
          toast("Transfert annullé  avec succée", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            type: "success",
          });
          setOpenAlert(false);
        } else {
          toast("Erreur", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            type: "error",
          });
        }
      })
      .catch((err) => {
        toast("Erreur", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          type: "error",
        });
      });
  };
  return (
    <div className="flex flex-col  w-full items-center">
      <div className=" grid grid-cols-6 xl:grid-cols-4  lg:grid-cols-3 md:grid-cols-2  gap-4    mt-16 shadow-xl	py-8 px-4  w-[90%] ">
        <div className="w-[180px] md:w-[130px] flex flex-col gap-1">
          <label className="text-md text-black font-semibold text-left">
            Status
          </label>
          <Select
            placeholder="Statut"
            options={options}
            value={selectedValue?.label}
            onChange={(value) =>
              setSelectedValue({ value: value.value, label: value.label })
            }
          />
        </div>
        <div className="w-[180px]  md:w-[130px] flex flex-col gap-1">
          <label className="text-md text-black font-semibold text-left">
            Date de début
          </label>
          <DatePicker
            selected={startDate}
            onChange={(date) => setStartDate(date)}
            className="border p-2 rounded h-[50px] w-[180px] md:w-[130px]"
            placeholderText="Date de début"
          />
        </div>
        <div className="w-[180px] md:w-[130px] flex flex-col gap-1">
          <label className="text-md text-black font-semibold text-left">
            Date de fin
          </label>
          <DatePicker
            selected={endDate}
            onChange={(date) => setEndDate(date)}
            className="border p-2 rounded h-[50px] w-[180px] md:w-[130px]"
            placeholderText="Date de fin"
          />
        </div>
        <div className="w-[180px] md:w-[130px] flex flex-col gap-1">
          <label className="text-md text-black font-semibold text-left">
            Partenaire
          </label>
          <Select
            placeholder="Partner"
            options={optionsPartner}
            value={selectedPartner?.label}
            onChange={(value) =>
              setSelectedPartner({ value: value.value, label: value.label })
            }
          />
        </div>
        <div className="w-[180px] md:w-[130px] flex flex-col gap-1">
          <label className="text-md text-black font-semibold text-left">
            Code
          </label>
          <input
            className="border-[1px] border-[#DCDCDC] h-[50px] rounded p-2"
            placeholder="Code"
            value={valueExp}
            onChange={(event) => setValueExp(event?.target?.value)}
          />
        </div>
        <div className="w-[180px] md:w-[130px] flex flex-col gap-1">
          <label className="text-md text-black font-semibold text-left">
            Montant
          </label>
          <input
            className="border-[1px] border-[#DCDCDC] h-[50px] rounded p-2 "
            placeholder="Montant"
            value={valueMontant}
            onChange={(event) => handleChangeMontant(event)}
          />
        </div>
      </div>

      <div className="mt-24 px-2 ">
        <Table
          data={filteredData}
          columns={columns}
          withColumn={"w-[200px] lg:w-[150px]"}
          withContainer={"w-[1600px] lg:w-[1000px]"}
          excel={true}
          openModal={() => setOpenModal(true)}
          setDataTransfert={setDataTransfert}
          loading={loading}
          isActions
          isCheckbox
          openAlert={(item) => {
            setTransferId(item);
            setOpenAlert(true);
          }}
        />
      </div>
      <Modal
        open={openModal}
        onClose={() => {
          setOpenModal(false);
          // formik.resetForm();
        }}
        className=" h-[400px] w-[550px] px-12 "
      >
        <span className="mt-8 text-[30px] text-[#5d55e8] font-bold ">
          Détail transfert
        </span>
        <div className="mx-auto flex flex-col gap-1 mt-8">
          <div>
            <div className="flex gap-2 items-center">
              <span className="font-semibold text-[20px]">
                Code transfert :
              </span>
              <span className=" text-[18px]">{dataTransfert?.code} </span>
            </div>
            <div className="flex gap-2 items-center">
              <span className="font-semibold text-[20px]">Date :</span>
              <span className=" text-[18px]">
                {" "}
                {moment(dataTransfert?.date).format("DD/MM/YYYY hh:mm")}
              </span>
            </div>
            <div className="flex gap-2 items-center">
              <span className="font-semibold text-[20px]">Expéditeur :</span>
              <span className=" text-[18px]">
                {dataTransfert?.nameExp} {dataTransfert?.prenomExp}
              </span>
            </div>
            <div className="flex gap-2 items-center">
              <span className="font-semibold text-[20px]">Destinataire :</span>
              <span className=" text-[18px]">
                {dataTransfert?.nameDes} {dataTransfert?.prenomDes}
              </span>
            </div>
            <div className="flex gap-2 items-center">
              <span className="font-semibold text-[20px]">
                Téléphone de destinataire :
              </span>
              <span className=" text-[18px]">{dataTransfert?.tel} </span>
            </div>
            <div className="flex gap-2 items-center">
              <span className="font-semibold text-[20px]">Montant :</span>
              <span className=" text-[18px]">
                {dataTransfert?.amount} {dataTransfert?.currency}{" "}
              </span>
            </div>
            <div className="flex gap-2 items-center">
              <span className="font-semibold text-[20px]">Statut :</span>
              <span className=" text-[18px]">
                {" "}
                {dataTransfert?.status === "created"
                  ? "Créé"
                  : dataTransfert?.status === "complete"
                  ? "Terminé"
                  : dataTransfert?.status === "consulted"
                  ? "Consulté"
                  : "Annulé"}{" "}
              </span>
            </div>
          </div>
        </div>
      </Modal>
      <ToastContainer />
      <ConfirmAlert
        open={openAlert}
        onCancel={() => setOpenAlert(false)}
        onConfirm={() => CancelTransferfn()}
      />
    </div>
  );
};

export default Home;
